export default __webpack_public_path__ + "assets/fonts/941c3692d95b2200000aed9a0ecbdc74.woff2";